import { getCookie, setCookie } from './lib/cookies'

/**
 * Note, this file is exported to its own bundle.
 * See `rollup.config.js`.
 */
addEventListener('DOMContentLoaded', () => {
	if (!CookieBanner.userHasSetPreference) {
		const banner = new CookieBanner()
		banner.append()
	}
})

class CookieBanner {
	static get userHasSetPreference () {
		return !!getCookie('vanoord_avg_cookie')
	}

	constructor() {
		this.element = document.createElement('div')
		this.element.id = 'cookie-banner'

		// Content element.
		const contentDiv = document.createElement('div')
		contentDiv.className = 'cookie-banner-content'
		this.element.appendChild(contentDiv)

		// Title.
		const title = document.createElement('h2')
		title.textContent = 'Cookies'
		contentDiv.appendChild(title)

		// Text.
		const url = 'https://www.vanoord.com/en/privacy-and-cookie-statement'
		const text = document.createElement('p')
		text.innerHTML =
			`We use functional and analytical cookies to improve our website.
			Third parties place tracking cookies for example (for the possibility) to view the videos from Vimeo.
			Your consent is required to place these tracking cookies.
			By clicking accept you consent to the placement of these cookies.
			You can always change your settings at a later date.
			For more information, please read our <a href="${url}" target="_blank">Privacy and Cookie statement</a>.`
		contentDiv.appendChild(text)

		// Accept button.
		const acceptButton = document.createElement('button')
		acceptButton.id = 'cookie-banner-accept'
		acceptButton.textContent = 'Accept cookies'
		acceptButton.addEventListener('click', () => this.onContinueClick(true))
		contentDiv.appendChild(acceptButton)

		// Reject button.
		const rejectButton = document.createElement('button')
		rejectButton.id = 'cookie-banner-reject'
		rejectButton.textContent = 'Decline cookies'
		rejectButton.addEventListener('click', () => this.onContinueClick(false))
		contentDiv.appendChild(rejectButton)

		// Close button.
		const closeButton = document.createElement('a')
		closeButton.classList.add('cookie-banner-close')
		closeButton.addEventListener('click', () => this.remove())
		contentDiv.appendChild(closeButton)
	}

	append () {
		document.body.appendChild(this.element)
		this.poll()
	}

	onContinueClick = (accepted) => {
		setCookie('vanoord_avg_cookie', accepted ? 'enabled' : 'disabled', 30)
		this.remove()
		if (accepted) {
			location.reload()
		}
	}

	remove () {
		this.element.parentNode?.removeChild(this.element)
	}

	// Although technically an unethical way, poll every x seconds to see if the cookie
	// hasn't been updated by some other source.
	poll = () => {
		if (!getCookie('vanoord_avg_cookie')) {
			setTimeout(this.poll, 1000)
		}
		else {
			this.remove()
		}
	}
}